import { triggerAPI } from 'modules/util';

const SPLITZ_URL = 'https://api.razorpay.com/v1/splitz/evaluate';
const SPLITZ_EXP_ID = 'Ir4WYflLrAO5ee';

informUsersAboutBetaSite();

function informUsersAboutBetaSite() {
  const betaEnabledInLocalStorage = localStorage.getItem('betaEnabled');

  if (betaEnabledInLocalStorage === 'true') {
    showBetaBanner();
  } else {
    fetchBetaEnabledStatusFromSplitz(betaEnabled => {
      if (betaEnabled) {
        showBetaBanner();
        // In case if beta is enabled, storing value in localStorage as cache
        localStorage.setItem('betaEnabled', 'true');
      }
    });
  }
}

function fetchBetaEnabledStatusFromSplitz(onComplete) {
  const payload = {
    id: getSessionId(),
    experiment_id: SPLITZ_EXP_ID
  };

  triggerAPI(
    SPLITZ_URL,
    'POST',
    (apiResponse, readyState) => {
      /*
      Ready state 4 means request fetching is done
      For more info read 👇
      https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState
    */
      if (readyState === 4) {
        onComplete(getBetaEnabledFromResponse(apiResponse));
      }
    },
    payload
  );
}

function getBetaEnabledFromResponse(apiResponse) {
  const splitzResponse = JSON.parse(apiResponse);
  if (splitzResponse.status_code === 200) {
    return splitzResponse.response.variant.variables[0].value === 'enabled';
  }
  // not showing the banner if an error in request
  return false;
}

function showBetaBanner() {
  // Replace with the code for displaying the beta banner
  document.getElementById('beta-banner').style.height = '56px';
}

/* Generating a unique session, if there isn't generated any */
function getSessionId() {
  const existingId = localStorage.getItem('docs-session-id');
  if (existingId) {
    return existingId;
  }
  const newSessionId = nanoid(36);
  localStorage.setItem('docs-session-id', newSessionId);
  return newSessionId;
}

/**
 * This snippet of code is directly copied from the module nanoid
 * If you wanna read more about this visit 👉 https://github.com/ai/nanoid
 *  */
function nanoid(t = 21) {
  let e = '',
    r = crypto.getRandomValues(new Uint8Array(t));
  for (; t--; ) {
    let n = 63 & r[t];
    e +=
      n < 36
        ? n.toString(36)
        : n < 62
        ? (n - 26).toString(36).toUpperCase()
        : n < 63
        ? '_'
        : '-';
  }
  return e;
}
